import moment from 'moment';
import { GET, POST } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/merchantPayable/${endpoint}`;
};

export const getAllPayments = (token) => {
  const endpoint = getEndpointWithPrefix('getAllPayables');
  return GET(endpoint, token).then((response) => {
    return response;
  });
};

export const getPayablesByMerchantId = (request, token) => {
  const endpoint = getEndpointWithPrefix('getMerchantPayables');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const filterMerchantPayables = (request, token) => {
  const endpoint = getEndpointWithPrefix('filterMerchantPayables');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const searchMerchantPayableById = (request, token) => {
  const endpoint = getEndpointWithPrefix('getMerchantPayableById');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const addPayment = (request, token) => {
  const endpoint = getEndpointWithPrefix('addMerchantPayable');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const getDetailsForAddPayments = (token) => {
  const endpoint = getEndpointWithPrefix('getMechantIds');
  return GET(endpoint, token).then((response) => {
    return response;
  });
};

export const getAllMerchantpayables = (page, token) => {
  const endpoint = getEndpointWithPrefix(`getAllMerchantPayables/${page}`);
  return GET(endpoint, token).then((response) => {
    return response;
  });
};

export const getAllMerchantPayableByFilters = (
  token,
  { startDate, endDate, merchantId } = {}
) => {
  const params = new URLSearchParams();
  if (merchantId) params.set('merchantId', merchantId);
  const qs = params.toString();
  const endpoint = getEndpointWithPrefix(
    `get-all-merchant-payable${qs ? `?${qs}` : ''}`
  );

  let body = null;
  if (startDate && endDate) {
    body = {
      startDate: moment(startDate).startOf('day').toISOString(),
      endDate: moment(endDate).endOf('day').toISOString(),
    };
  }

  return POST(endpoint, body, token);
};
